import React from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardContent,
  CardTitle,
  CardDescription,
} from "components/ui/card";
import { navItems } from "constants/navItems";
import { useAuth } from "context/AuthContext";

// Adjust the path if your assets folder location differs
import appIcon from "../logo192.png";

const Home = () => {
  const { user } = useAuth();
  const quickNavItems = navItems.filter((item) => item.quickNav);

  return (
    <div className="flex w-full flex-col items-center gap-6" dir="rtl">
      <Card className="w-full max-w-3xl overflow-hidden border border-border shadow-md">
        {/* One responsive “single card” layout:
            - Mobile: stacked (image above text)
            - Desktop: side-by-side (image right, text left) */}
        <div className="grid grid-cols-1 sm:grid-cols-5">
          {/* Image */}
          <div className="sm:col-span-2 bg-accent/10 flex items-center justify-center p-6">
            <img
              src={appIcon}
              alt="Store Management"
              className="h-28 w-28 sm:h-40 sm:w-40 object-contain drop-shadow"
              draggable="false"
            />
          </div>

          {/* Text */}
          <div className="sm:col-span-3">
            <CardHeader className="pb-3">
              <CardTitle className="text-2xl sm:text-3xl font-bold text-primary">
                ניהול חנות
              </CardTitle>
              <CardDescription className="mt-2 text-muted-foreground">
                מערכת לניהול הזמנות, תגיות, סינון ומיון — בצורה פשוטה, מהירה ונוחה.
              </CardDescription>
            </CardHeader>

            <CardContent className="pt-0">
              <p className="text-sm text-muted-foreground">
                התחילו דרך התפריט בפינה הימנית, חפשו הזמנות לפי תגיות, וסננו לפי סטטוס ותאריכים.
              </p>
            </CardContent>
          </div>
        </div>
      </Card>

      {/* Quick navigation — shown only to a logged-in user, as a shortcut into the
          main screens without opening the sidebar first. */}
      {user && quickNavItems.length > 0 && (
        <section className="w-full max-w-3xl">
          <h2 className="mb-3 text-sm font-medium text-muted-foreground">
            ניווט מהיר
          </h2>

          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
            {quickNavItems.map((item) => {
              const Icon = item.icon;

              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className="group rounded-lg outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
                >
                  <Card className="flex aspect-square flex-col items-center justify-center gap-2 border border-border p-3 text-center transition-colors group-hover:border-primary group-hover:bg-accent/40">
                    <Icon className="h-8 w-8 text-primary" />
                    <span className="text-sm font-semibold text-foreground">
                      {item.label}
                    </span>
                    <span className="text-xs text-muted-foreground">
                      {item.description}
                    </span>
                  </Card>
                </Link>
              );
            })}
          </div>
        </section>
      )}
    </div>
  );
};

export default Home;
